import ConfirmContainer from "./confirm";

export { showConfirmation } from "./confirm";

export default ConfirmContainer;
